import { render, staticRenderFns } from "./PageRecettesListe.vue?vue&type=template&id=5d982503&"
import script from "./PageRecettesListe.vue?vue&type=script&lang=js&"
export * from "./PageRecettesListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d982503')) {
      api.createRecord('5d982503', component.options)
    } else {
      api.reload('5d982503', component.options)
    }
    module.hot.accept("./PageRecettesListe.vue?vue&type=template&id=5d982503&", function () {
      api.rerender('5d982503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Recettes/PageRecettesListe.vue"
export default component.exports